import { createAction, props } from '@ngrx/store';
import { Lead } from '@shared/models/lead';

export const loadLead = createAction('[Leads] Load Lead', props<{ leadId: number }>());

export const loadLeadSuccess = createAction('[Leads] Load Lead Success', props<{ lead: Lead }>());

export const loadLeadFailure = createAction('[Leads] Load Lead Failure', props<{ error: any }>());
